import { Typography } from '@twistopayments/design-system/components/atoms/typography'
import { isNil } from 'ramda'

import type { ArticleListResponse } from '@twisto/api-cms'
import { useIsMobile } from '@twisto/hooks'

import { useAdditionalData } from 'homepage/libs/context'

import { ContentListLink } from '../subcategory-list/subcategory-content-list/'

import * as styles from './popular-article-list.styles'

type Props = {
  articles?: ArticleListResponse
}

const MAX_MOBILE_ARTICLES = 6

export const PopularArticleList = ({ articles }: Props) => {
  const isMobile = useIsMobile()
  const { staticTexts } = useAdditionalData()
  if (isNil(articles) || isNil(articles.data) || articles.data.length === 0) {
    return null
  }

  const slicedArticles = articles.data.slice(
    0,
    isMobile ? MAX_MOBILE_ARTICLES : articles.data.length
  )

  return (
    <section css={styles.section}>
      <nav css={styles.container}>
        <Typography
          color="textPrimary"
          component="h2"
          fontWeight="heavy"
          variant="h1"
        >
          {staticTexts?.popularArticleListTitle || ''}
        </Typography>
        <ul css={styles.list}>
          {slicedArticles.map((article) => (
            <ContentListLink
              key={article.id}
              css={styles.listItem}
              text={article.headline}
              to={article.path}
            />
          ))}
        </ul>
      </nav>
    </section>
  )
}
